import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { getAuth, signInAnonymously } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB4zT1zc9XuNiklXX842yMKjDp8YBEgj4w",
  authDomain: "advdev-development.firebaseapp.com",
  databaseURL: "https://advdev-development.firebaseio.com",
  projectId: "advdev-development",
  storageBucket: "advdev-development.appspot.com",
  messagingSenderId: "109380333126",
  appId: "1:109380333126:web:b763e788ca126fb9c7a447",
  measurementId: "G-PR7399CE1Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Analytics
export const analytics = getAnalytics(app);

// Initialize Auth
export const auth = getAuth(app);

// Sign in anonymously
export const signIn = async () => {
  try {
    await signInAnonymously(auth);
    console.log('Signed in anonymously');
  } catch (error) {
    console.error('Error signing in:', error);
  }
}; 